import { QuoteCoverageCue } from "./QuoteCoverageCue";

export enum PropertyType {
  None = 0,
  ApartmentCondo = "A",
  SingleFamilyHome = "S",
  TownHouse = "T",
  StudentDorm = "D",
}

export class QuoteInfo {
  propertyType = PropertyType.None;
  isManufactured: boolean | undefined = undefined;
  requiredRenters: boolean | undefined = undefined;
  isMasonryConstruction: boolean | undefined = undefined;
  numberOfLosses: number | undefined = undefined;
  lastLossDate = "";
  animalHarm: boolean | undefined = undefined;
  // Always on
  insurePersonalBelongings = true;
  coverageStartDate = "";
  policyLength = 1;
  quoteCoverageCue = new QuoteCoverageCue();
  hasStateDisclosure: boolean | undefined = undefined;
}
